import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomCodeService {
  private API = environment.apiURL 

  constructor(private _http: HttpClient) { }

  getCustomCodes(customCode): Observable<any> {
    return this._http.get<any>(environment.apiURL+`/custom-codes/${customCode}`,{observe: 'response'});
  }
  getCustomCodeLink(customCode): Observable<any>{
    return this._http.get<any>(environment.apiURL+`/custom-codes/${customCode}/shareable-link`,{observe: 'response'});
  }
  updateAuthentication(customCode,authenticationDeatils): Observable<any>{
    return this._http.put<any>(environment.apiURL+`/custom-codes/${customCode}/authentication`, authenticationDeatils,{observe: 'response'});
  }
  getCustomCodeDetails(customCode){
    return this._http.get<any>(this.API + `/custom-codes/${customCode}`);
  }
  getCustomCodeList(merchantUuid): Observable<any>{
    return this._http.get<any>(environment.apiURL+`/merchants/${merchantUuid}/custom-codes`,{observe: 'response'});
  }
}